'use strict';

angular.module('PinMeTo.directives').directive('contenteditable', [
	function () {
		return {
			restrict: 'A',
			require: '?ngModel',
			link: function (scope, element, attrs, ngModel) {
				if (!ngModel) {
					return;
				}

				let opts = {};
				angular.forEach(
					['stripBr', 'noLineBreaks', 'selectNonEditable', 'moveCaretToEndOnChange', 'stripTags'],
					function (opt) {
						let o = attrs[opt];
						opts[opt] = o && o !== 'false';
					}
				);

				element.bind('input', function () {
					scope.$apply(function () {
						let html;
						html = element.html();
						if (opts.stripTags) {
							html = html
								.replace(/<div>/g, '')
								.replace(/<br>/g, '\n')
								.replace(/<\/div>/g, '\n');
							html = html.replace(/<\S[^><]*>/g, '');
							html = html.replace(/&nbsp;/g, ' ');
						}
						ngModel.$setViewValue(html);
					});
				});

				// model -> view
				let oldRender = ngModel.$render;
				ngModel.$render = function () {
					let el, el2, range, sel;
					if (!!oldRender) {
						oldRender();
					}
					let html = ngModel.$viewValue || '';
					if (opts.stripTags) {
						html = html
							.replace(/<div>/g, '')
							.replace(/<br>/g, '\n')
							.replace(/<\/div>/g, '\n');
						html = html.replace(/<\S[^><]*>/g, '');
						html = html.replace(/&nbsp;/g, ' ');
					}

					element.html(html);
					if (opts.moveCaretToEndOnChange) {
						el = element[0];
						range = document.createRange();
						sel = window.getSelection();
						if (el.childNodes.length > 0) {
							el2 = el.childNodes[el.childNodes.length - 1];
							range.setStartAfter(el2);
						} else {
							range.setStartAfter(el);
						}
						range.collapse(true);
						sel.removeAllRanges();
						sel.addRange(range);
					}
				};
				if (opts.selectNonEditable) {
					element.bind('click', function (e) {
						let range, sel, target;
						target = e.toElement;
						if (target !== this && angular.element(target).attr('contenteditable') === 'false') {
							range = document.createRange();
							sel = window.getSelection();
							range.setStartBefore(target);
							range.setEndAfter(target);
							sel.removeAllRanges();
							sel.addRange(range);
						}
					});
				}
			}
		};
	}
]);
